import { OpenAPIV3 } from "../@types";
import { Avatar, AvatarPictureType } from "../model";

/** Provides generic HTML (Bootstrap 3 in this version) for rendering Grid cells. */
export class CellRenderingLogic {

  /**
   * Gets an agGrid cell renderer based on the property schema.
   * @param schemaProp The schema of the property that is being rendered
   * @returns A cell renderer for AGGrid. Currently always a function: May later be a component.
   * Null, if the column should be rendered using default functionality.
   */
  public static getCellRenderer(schemaProp: OpenAPIV3.NonArraySchemaObject): (item: any) => string {
    switch (schemaProp.format) {
      case "Employment":
        return (item) => `<div>${this.getAvatar(item?.value?.personalInfo.avatar)} ${ item?.value?.personalInfo.avatar.sortableName || "-" }</div>`;
      case "Avatar":
        return (item) => `<div>${this.getAvatar(item?.value)} ${ item?.value?.sortableName || "-" }</div>`;
    }
    return null;
  }

  /**
   * Renders an avatar as a picture / icon
   * @param avatar The avatar objec that should be rendered.
   * @param fontSize Optional font size. Default is 2em, which typically good in agGrid.
   * @returns HTML for the avatar.
   */
  public static getAvatar(avatar: Avatar, fontSize = "2em"): string {
    const isImage = avatar
      && (avatar.pictureType === AvatarPictureType.Uploaded || avatar.pictureType === AvatarPictureType.Gravatar)
      && avatar.url?.substring(0, 4).toLowerCase() === "http";
    const isPersonIcon = avatar != null && !isImage && avatar.entityType !== "company";
    const initials = avatar ? (avatar.initials || "-") : "?";
    if (isImage) {
      return `<span class="salaxy-avatar" style="font-size: ${fontSize}"><img src="${avatar.url}" /></span>`;
    }
    return `<i class="salaxy-avatar fa ${ isPersonIcon ? "fa-user" : "fa-square" }" style="color: ${ avatar?.color || "gray"}; font-size: ${fontSize}">
      <strong>${initials}</strong></i>`;
  }

}